const BuildingAmenitiesConstants = {
    booleanFields: {
        // Grouped by categories returned in listing details endpoint
        // Key value pairs are display name and field in details response
        // Endpoint is built via [field + keyword], ex: hasCentralAirConditioning
        airConditioningTypes: {
            keyword: 'AirConditioning',
            sectionLabel: 'Air Conditioning',
            category: 'airConditioningTypes',
            fields: {
                Central: 'hasCentral',
                Wall: 'hasWall',
                Window: 'hasWindow',
            },
        },
        applianceTypes: {
            keyword: 'Appliance',
            sectionLabel: 'Appliances',
            category: 'applianceTypes',
            fields: {
                'Convection Oven': 'hasConvectionOven',
                Dishwasher: 'hasDishwasher',
                'Double Oven': 'hasDoubleOven',
                Freezer: 'hasFreezer',
                'Garbage Disposal': 'hasGarbageDisposal',
                Microwave: 'hasMicrowaveOven',
                Oven: 'hasOven',
                Range: 'hasRange',
                Refrigerator: 'hasRefrigerator',
                'Trash Compactor': 'hasTrashCompactor',
                'Washer/Dryer Hookups': 'hasWasherDryerHookups',
            },
        },
        communicationTypes: {
            sectionLabel: 'Communication Types',
            category: 'communicationTypes',
            fields: {
                'Building-wide Wireless': 'hasBuildingWideWireless',
                'Cable TV': 'hasCableTv',
                'High Speed Internet': 'hasHighSpeedInternet',
                'Satellite TV': 'hasSatelliteTv',
            },
        },
        communityRoomTypes: {
            keyword: 'CommunityRoom',
            sectionLabel: 'Community Rooms',
            category: 'communityRoomTypes',
            fields: {
                'Business Center': 'hasBusinessCenter',
                'Club House': 'hasClubHouse',
                'Conference Center': 'hasConferenceRoom',
                'Fitness Center': 'hasFitnessCenter',
                'Game Room': 'hasGameRoom',
                Library: 'hasLibrary',
                Lounge: 'hasLounge',
                'Party Room': 'hasPartyRoom',
                'Pet Washing Station': 'hasPetWashingStation',
                Theater: 'hasTheater',
            },
        },
        floorCoveringTypes: {
            keyword: 'FloorCovering',
            sectionLabel: 'Additional Floor Coverings',
            category: 'floorCoveringTypes',
            fields: {
                Carpet: 'hasCarpet',
                Concrete: 'hasConcrete',
                Hardwood: 'hasHardwood',
                Laminate: 'hasLaminate',
                Linoleum: 'hasLinoleum',
                Slate: 'hasSlate',
                Softwood: 'hasSoftwood',
                Tile: 'hasTile',
                Vinyl: 'hasVinyl',
            },
        },
        heatingSourceTypes: {
            keyword: 'HeatingSource',
            sectionLabel: 'Heating Sources',
            category: 'heatingSourceTypes',
            fields: {
                Electric: 'hasElectric',
                Gas: 'hasGas',
                'Heat pump': 'hasHeatPump',
                Oil: 'hasOil',
                'Propane / Butane': 'hasPropaneButane',
                Solar: 'hasSolar',
            },
        },
        leaseLengths: {
            keyword: 'LeaseLengths',
            sectionLabel: 'Lease Lengths',
            category: 'leaseLengths',
            fields: {
                'One Year': 'hasOneYear',
                'More Than 1 Year': 'hasMoreThanOneYear',
                'Less Than 1 Year': 'hasLessThanOneYear',
                'Six Months': 'hasSixMonths',
                Monthly: 'hasMonthly',
                Flexible: 'hasFlexible',
            },
        },
        outdoorCommonAreaTypes: {
            keyword: 'OutDoorCommonArea',
            sectionLabel: 'Outdoor Common Areas',
            category: 'outdoorCommonAreaTypes',
            fields: {
                Deck: 'hasDeck',
                Garden: 'hasGarden',
                Gazebo: 'hasGazebo',
                Lawn: 'hasLawn',
                Patio: 'hasPatio',
                'Picnic Area': 'hasPicnicArea',
                Playground: 'hasPlayground',
                'Rooftop Deck': 'hasRooftopDeck',
                Trail: 'hasTrail',
                'Water Feature': 'hasWaterFeature',
            },
        },
        parkingTypes: {
            keyword: 'Parking',
            sectionLabel: 'Parking',
            category: 'parkingTypes',
            fields: {
                'Attached Garage': 'hasAttachedGarage',
                'Covered Parking': 'hasCoveredParking',
                'Detached Garage': 'hasDetachedGarage',
                'Multi-level Garage': 'hasMultiLevelGarage',
                'Parking Lot': 'hasParkingLot',
                'Underground Garage': 'hasUndergroundGarage',
            },
        },
        securityTypes: {
            keyword: 'Security',
            sectionLabel: 'Security',
            category: 'securityTypes',
            fields: {
                'Controlled Access': 'hasControlledAccess',
                Doorman: 'hasDoorman',
                'Gated Entry': 'hasGatedEntry',
                Intercom: 'hasIntercom',
                'Night Patrol': 'hasNightPatrol',
            },
        },
        sportCourtTypes: {
            keyword: 'SportCourt',
            sectionLabel: 'Sport Courts',
            category: 'sportCourtTypes',
            fields: {
                'Basketball Court': 'hasBasketball',
                'Bocce Court': 'hasBocce',
                'Multi-purpose Court': 'hasMultiPurpose',
                'Other Sports Court': 'hasOther',
                'Racquetball Court': 'hasRacquetball',
                'Shuffleboard Court': 'hasShuffleboard',
                'Sports Field': 'hasSportsField',
                'Tennis Court': 'hasTennis',
                'Volleyball Court': 'hasVolleyball',
            },
        },
        utilitiesIncluded: {
            keyword: 'UtilityIncluded',
            sectionLabel: 'Utilities Included in Rent',
            category: 'utilitiesIncluded',
            fields: {
                'Air Conditioning': 'hasAirConditioning',
                'Cable TV': 'hasCableTv',
                Electricity: 'hasElectricity',
                Garbage: 'hasGarbage',
                Gas: 'hasGas',
                Heating: 'hasHeating',
                'Hot Water': 'hasHotWater',
                Internet: 'hasInternet',
                'Sewage Included': 'hasSewage',
                Water: 'hasWater',
            },
        },
        viewTypes: {
            keyword: 'View',
            sectionLabel: 'Views',
            category: 'viewTypes',
            fields: {
                City: 'hasCity',
                'Golf Course': 'hasGolfCourse',
                Mountain: 'hasMountain',
                Park: 'hasPark',
                Territorial: 'hasTerritorial',
                Water: 'hasWater',
                Wooded: 'hasWooded',
            },
        },
        otherTypes: {
            // individual boolean fields that are not grouped in a category
            sectionLabel: 'Other Features',
            fields: {
                '24-Hour Maintenance': 'hasTwentyFourHourMaintenance',
                'Assisted Living': 'hasAssistedLiving',
                Barbecue: 'hasBarbecue',
                'Bicycle Storage': 'hasBicycleStorage',
                'Ceiling Fan': 'hasCeilingFan',
                'Disabled Access': 'hasDisabledAccess',
                'Dry Cleaning Drop-off': 'hasDryCleaningDropOff',
                Elevator: 'hasElevator',
                Fireplace: 'hasFireplace',
                'Guest Suite': 'hasGuestSuite',
                'Hot Tub': 'hasHotTub',
                'Income Restricted': 'isIncomeRestricted',
                'On-site Management': 'hasOnsiteManagement',
                'Online Maint. Portal': 'hasOnlineMaintenancePortal',
                'Online Rent Payment': 'hasOnlineRentPayment',
                'Over 55 Community': 'isOver55',
                'Package Service': 'hasPackageService',
                'Patio or Balcony': 'hasPatioBalcony',
                'Pet Park': 'hasPetPark',
                Sauna: 'hasSauna',
                'Smoking Allowed': 'smokingAllowed',
                'Spanish-speaking Staff': 'hasSpanishSpeakingStaff',
                'Storage Space': 'hasStorageSpace',
                'Swimming Pool': 'hasSwimmingPool',
                'Valet Trash': 'hasValetTrash',
            },
        },
    },
    stringFields: {
        'Description on Zillow': 'zillowDescription',
        'Association Name': 'associationName',
        'Manager Name': 'managerName',
        Architect: 'architect',
        'Buses Nearby': 'busesNearby',
        'Rail Nearby': 'railNearby',
        'Pet Policy Description': 'petPolicyDescription',
        'Parking Description': 'parkingDescription',
        'Parking Rent Description': 'parkingRentDescription',
        'Nearby Amenity #1': 'nearbyAmenity1',
        'Nearby Amenity #2': 'nearbyAmenity2',
        'Nearby Amenity #3': 'nearbyAmenity3',
        'Nearby Amenity #4': 'nearbyAmenity4',
    },
    maxLengthFields: {
        parkingDescription: 130,
        petPolicyDescription: 150,
    },
    feeFields: {
        'Application Fee': 'applicationFee',
        'Administrative Fee': 'administrativeFee',
        'Minimum Deposit': 'depositFeeMin',
        'Maximum Deposit': 'depositFeeMax',
    },
    numericFields: {
        'Year Built': 'yearBuilt',
        'Year Remodeled': 'yearRemodeled',
        'Story Count': 'storyCount',
        'Units in Building': 'numUnits',
    },
};
export default BuildingAmenitiesConstants;
